var exports = {
  "x6": "MemberListItem.module__button___OVY0Mj",
  "OG": "MemberListItem.module__nameRoleColored___OVY0Mj",
  "w1": "MemberListItem.module__buttonOffline___OVY0Mj",
  "dP": "MemberListItem.module__buttonContextMenuOpen___OVY0Mj",
  "vs": "MemberListItem.module__memberFocusRing___OVY0Mj",
  "Vg": "MemberListItem.module__grid___OVY0Mj",
  "Qs": "MemberListItem.module__content___OVY0Mj",
  "H": "MemberListItem.module__avatarContainer___OVY0Mj",
  "TT": "MemberListItem.module__userInfoContainer___OVY0Mj",
  "VW": "MemberListItem.module__nameContainer___OVY0Mj",
  "UU": "MemberListItem.module__name___OVY0Mj",
  "w4": "MemberListItem.module__memberCustomStatus___OVY0Mj",
  "Dd": "MemberListItem.module__ownerIcon___OVY0Mj",
  "j$": "MemberListItem.module__crownIcon___OVY0Mj",
  "a1": "MemberListItem.module__userTag___OVY0Mj",
};

module.exports = exports;
